import { render, staticRenderFns } from "./CRUDTable2.vue?vue&type=template&id=2849b53a"
import script from "./CRUDTable2.vue?vue&type=script&lang=js"
export * from "./CRUDTable2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports